
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface SubscriptionStatus {
  hasActiveSubscription: boolean;
  plan: string | null;
  status: string | null;
  isLoading: boolean;
}

export const useSubscriptionStatus = () => {
  const { user } = useAuth();
  const [subscriptionStatus, setSubscriptionStatus] = useState<SubscriptionStatus>({
    hasActiveSubscription: false,
    plan: null,
    status: null,
    isLoading: true,
  });

  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      if (!user) {
        const noSubscriptionStatus = {
          hasActiveSubscription: false,
          plan: null,
          status: null,
          isLoading: false,
        };
        setSubscriptionStatus(noSubscriptionStatus);
        return;
      }

      // Allow all logged-in users to access features as if they have a subscription
      const newStatus = {
        hasActiveSubscription: true,
        plan: 'free' as any,
        status: 'active' as any,
        isLoading: false,
      };

      setSubscriptionStatus(newStatus);
    };

    checkSubscriptionStatus();
  }, [user]);

  return subscriptionStatus;
};
